let modalSwiper, modalThumbs;

// Ensure functions are globally available
window.openModal = function (imageSrc) {
    document.getElementById('myModal').style.display = "flex";
    document.getElementById('myModal').classList.add('active'); 

    let slides = document.querySelectorAll('.modal-slide');
    let slideIndex = Array.from(slides).findIndex(img => img.src.includes(imageSrc.split("?")[0]));

    if (slideIndex === -1) slideIndex = 0; // Default to first if not found

    // Check if Swiper is already initialized
    if (!modalSwiper) {
        // Initialize Thumbnail Swiper
        modalThumbs = new Swiper(".modalThumbs", {
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
        });

        // Initialize Main Swiper
        modalSwiper = new Swiper(".modalSwiper", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: modalThumbs,
            },
            on: {
                init: function () {
                    updateSlideCounter(); // Call updateSlideCounter only after initialization
                },
                slideChange: updateSlideCounter,
            },
        });
    } else {
        modalSwiper.update(); // Ensure Swiper updates when opening modal again
    }

    modalSwiper.slideTo(slideIndex);
    updateSlideCounter();
};

// Close modal function
window.closeModal = function () {
    document.getElementById('myModal').style.display = "none";
    document.getElementById('myModal').classList.remove('active');
};

// Update Slide Counter
function updateSlideCounter() {
    if (!modalSwiper) return; // Ensure Swiper is initialized before accessing its properties

    let totalSlides = modalSwiper.slides.length;
    let currentIndex = modalSwiper.realIndex + 1; // Swiper index starts at 0
    document.getElementById("slide-counter").innerText = `${currentIndex} / ${totalSlides}`;
}

// Attach close event listener
document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".close").addEventListener("click", closeModal);

    // Close modal when clicking outside the content
    // window.onclick = function (event) {
    //     let modal = document.getElementById('myModal');
    //     if (event.target === modal) {
    //         closeModal();
    //     }
    // };
});
